import { useTranslation } from 'react-i18next';
import { Drawer, List, Notification } from 'rsuite';
import { useEffect, useState } from 'react';
import { workModeUsers } from '@/services/combinedModes.service';
import { format } from 'date-fns';

const UserListDrawer = ({ open, onClose, selectedRow }) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = async () => {
    if (!selectedRow || !selectedRow.formattedDate || !selectedRow.timeslot || !selectedRow.mode) {
      console.warn('Invalid selectedRow:', selectedRow);
      setError(t('Invalid selection data. Please try again.'));
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      console.log('Fetching users with:', {
        date: selectedRow.formattedDate,
        timeslot: selectedRow.timeslot,
        mode: selectedRow.mode
      });
      const response = await workModeUsers(
        selectedRow.formattedDate,
        selectedRow.timeslot,
        selectedRow.mode
      );
      console.log('API response:', response);
      setUsers(Array.isArray(response) ? response : []);
    } catch (err) {
      console.error('Error fetching users:', err.message);
      setError(t('Failed to load users: ') + err.message);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('useEffect triggered. Open:', open, 'SelectedRow:', selectedRow);
    if (open && selectedRow) {
      fetchUsers();
    } else {
      setUsers([]);
      setError(null);
    }
  }, [open, selectedRow, t]);

  return (
    <Drawer backdrop size={400} placement="right" open={open} onClose={onClose}>
      <Drawer.Header>
        <Drawer.Title style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'normal' }}>
          {selectedRow
            ? `${t('Users for')} ${selectedRow.displayMode} (${selectedRow.timeslot}, ${
                selectedRow.formattedDate
              })`
            : t('Users')}
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        {error && (
          <Notification type="error" header={t('Error')} closable>
            {error}
          </Notification>
        )}
        {loading ? (
          <p>{t('Loading...')}</p>
        ) : users.length === 0 ? (
          <p>{t('No users found')}</p>
        ) : (
          <List>
            {users.map((user, index) => (
              <List.Item
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px 15px',
                  borderBottom: '1px solid #e5e5e5'
                }}
              >
                <div>
                  <div
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '16px',
                      color: '#333'
                    }}
                  >
                    {user?.firstname || ''} {user?.lastname || ''}
                  </div>
                  <div
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '12px',
                      color: '#666',
                      marginTop: '4px'
                    }}
                  >
                    ( {user.gpn || ''})
                  </div>
                </div>
                <div
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontWeight: 400,
                    fontSize: '14px',
                    color: '#666'
                  }}
                >
                  {user.sl || ''}
                </div>
              </List.Item>
            ))}
          </List>
        )}
      </Drawer.Body>
    </Drawer>
  );
};

export default UserListDrawer;
